import React, { Component } from 'react';
import PropTypes from 'prop-types';

import InlineSVG from 'react-inlinesvg';
import ChatBubble from '../ChatBubble/ChatBubbleAsync';

import { Link } from 'react-router';

import mailIcon from './mail.svg';
import phoneIcon from './phone.svg';
import footerIcons from './footer-icons.jpg';
import footerIcons2x from './footer-icons@2x.jpg';
import instaIcon from './insta-icon.svg';
import fbIcon from './fb-icon.svg';
import { FormattedMessage } from 'react-intl';

export default class Footer extends Component {
    renderExtendedFooter() {
        if (this.props.hideExtended) return null;
        return (
            <div className="footer">
                <div className="container">
                    <div className="row">
                        <div className="col-xs-12 col-sm-4 col-md-3">
                            <h4 className="footer-title">
                                <FormattedMessage
                                    defaultMessage="Nakupování"
                                    id={'footer.shoppingTitle'}
                                />
                            </h4>
                            <ul className="footer-nav">
                                <li>
                                    <Link to="/informace-o-doprave">
                                        <FormattedMessage
                                            defaultMessage="Doprava a platba"
                                            id={'footer.deliveryPayment'}
                                        />
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/svatebni-balicky">
                                        <FormattedMessage
                                            defaultMessage="Krabičky na svatbu"
                                            id={'global.weddingGifts'}
                                        />
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/firemni-darky">
                                        <FormattedMessage
                                            defaultMessage="Firemní dárky"
                                            id={'global.corporateGifs'}
                                        />
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/caste-dotazy">
                                        <FormattedMessage
                                            defaultMessage="Časté dotazy"
                                            id={'footer.faqs'}
                                        />
                                    </Link>
                                </li>

                                <li>
                                    <Link to="/kontakt">
                                        <FormattedMessage
                                            defaultMessage="Kontakt"
                                            id={'global.contact'}
                                        />
                                    </Link>
                                </li>
                            </ul>
                        </div>

                        <div className="col-xs-12 col-sm-4 col-md-3">
                            <h4 className="footer-title">Dárková krabička</h4>
                            <ul className="footer-nav">
                                <li>
                                    <Link to="/o-nas">
                                        <FormattedMessage
                                            defaultMessage="Náš příběh"
                                            id={'footer.story'}
                                        />
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/lookbook">
                                        <FormattedMessage
                                            defaultMessage="Lookbook"
                                            id={'footer.lookbook'}
                                        />
                                    </Link>
                                </li>

                                <li>
                                    <a href="mailto:info@darkovakrabicka.cz">
                                        <FormattedMessage
                                            defaultMessage="Dodavatelé"
                                            id={'footer.suppliers'}
                                        />
                                    </a>
                                </li>
                                <li>
                                    <Link to="/obchodni-podminky">
                                        <FormattedMessage
                                            defaultMessage="Obchodní podmínky"
                                            id={'footer.terms'}
                                        />
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/ochrana-osobnich-udaju">
                                        <FormattedMessage
                                            defaultMessage="Ochrana osobních údajů"
                                            id={'footer.terms2'}
                                        />
                                    </Link>
                                </li>
                            </ul>
                        </div>

                        <div className="col-xs-12 col-sm-4 col-md-3">
                            <h4 className="footer-title">
                                <FormattedMessage
                                    defaultMessage="Máte dotaz ?"
                                    id={'footer.questionTitle'}
                                />
                            </h4>
                            <ul className="footer-nav">
                                <li>
                                    <p className="footer-contact-info">
                                        <InlineSVG src={mailIcon} />
                                        <a href="mailto:info@darkovakrabicka.cz">
                                            info@darkovakrabicka.cz
                                        </a>
                                    </p>
                                </li>
                                <li>
                                    <p className="footer-contact-info">
                                        <InlineSVG src={phoneIcon} />
                                        +420 277 277 939
                                    </p>
                                </li>
                            </ul>
                        </div>

                        <div className="col-xs-12 col-sm-4  col-md-3 hidden-xs hidden-sm">
                            <h4 className="footer-title">
                                <FormattedMessage
                                    defaultMessage="Sociální sítě"
                                    id={'footer.socialTitle'}
                                />
                            </h4>
                            <div className="footer-socials">
                                <a
                                    href="https://www.instagram.com/darkovakrabicka_cz/"
                                    target="_blank"
                                >
                                    <img src={instaIcon} alt="instagram" />
                                </a>
                                <a
                                    href="https://www.facebook.com/darkovakrabicka.cz/"
                                    target="_blank"
                                >
                                    <img src={fbIcon} alt="facebook" />
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
    render() {
        return (
            <footer className="footer-wrapper">
                {this.renderExtendedFooter()}
                <div className="footer-notes-wrapper">
                    <div className="container">
                        <div className="footer-notes">
                            <div className="left">
                                <img
                                    src={footerIcons}
                                    srcSet={`${footerIcons2x} 2x`}
                                    alt="partneři"
                                />
                            </div>

                            <div className="right">
                                <div>Dárková krabička s.r.o © {new Date().getFullYear()}</div>
                                <small>
                                    <FormattedMessage
                                        defaultMessage="Při poskytování služeb nám pomáhají soubory cookie. Používáním
                                    webu vyjadřujete souhlas."
                                        id={'footer.cookies'}
                                    />
                                </small>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>
        );
    }
}

Footer.propTypes = {
    hideExtended: PropTypes.bool.isRequired
};
